import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { fetchKeywordProducttype } from '@/api/keywordAnalysis/api'
import type { KeywordProducttype } from '@/api/keywordAnalysis/types'

export function useKeywordProducttype(
  producttypeKey: string,
): UseQueryResult<KeywordProducttype | null> {
  return useQuery({
    queryKey: ['keyword-producttype', producttypeKey],
    queryFn: ({ signal }) => fetchKeywordProducttype(producttypeKey, signal),
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  })
}
